import { DraftDesignConfiguration } from '@/types';
import { StoreState } from '@/redux/types';
import { getConfiguration } from './getConfiguration';

export const getDesignByConfigurationId = (state: StoreState, cid: number) =>
  (getConfiguration(state, cid) as DraftDesignConfiguration).design;
